import React, { useContext, useEffect, useCallback, useState } from 'react';
import { loadStripe } from "@stripe/stripe-js";
import { Elements, PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { TenantContext } from "tenant/TenantContext";
import _ from "lodash";
import { extractError } from 'api/ErrorUtil';
import { PAYMENTINTENT_CARD_TOKEN_URL } from "config/config";
import { API } from "api/API";

const StripeElements = ({ formData, saveCardFunction, handlePaymentResult }) => {
    const { businessConfig } = useContext(TenantContext);
    const [stripeData, setStripeData] = useState({ stripePromise: {}, errors: {}, paymentIntent: {}, showResult: false, stripePromiseLoaded: false });

    useEffect(() => {
        const stripePromise = loadStripe(businessConfig.publishablekey);
        setStripeData({
            ...stripeData,
            stripePromise: stripePromise,
            stripePromiseLoaded: true,
        });

    }, []);
    return (
        <>

            {stripeData.stripePromiseLoaded && <Elements stripe={stripeData.stripePromise}
                options={{
                    mode: "setup",
                    currency: businessConfig.currency.toLowerCase(),
                    setup_future_usage: "off_session",
                    payment_method_types: ["card"]

                }}>
                <StripePaymentElement formData={formData} saveCardFunction={saveCardFunction} handlePaymentResult={handlePaymentResult} />
            </Elements>}
        </>
    )
}



const StripePaymentElement = ({ formData, saveCardFunction, handlePaymentResult }) => {
    const { businessConfig } = useContext(TenantContext);
    const [paymentElementComplete, setPaymentElementComplete] = useState()
    const [setSetupIntent, setupIntent] = useState({});
    const stripe = useStripe();
    const elements = useElements();

    const getSetupIntent = async () => {
        let setupIntentResponse = null;
        if (_.isEmpty(setupIntent)) {

            setupIntentResponse = await API.post(PAYMENTINTENT_CARD_TOKEN_URL, {
                ...formData
            });
            console.log(setupIntentResponse.data);
            return setupIntentResponse.data;
        }
    };

    const savePaymentCard = async (event) => {
        let stripeResponse = null;
        try {
            //get client secret
            let setupIntent = await getSetupIntent()

            if (!paymentElementComplete) {
                handlePaymentResult({
                    errors: { message: "Credit Card form is not complete" },
                    paymentStatus: "ERROR",
                });
                return false;
            }

            // Trigger form validation and wallet collection
            const { error: submitError } = await elements.submit();
            if (submitError) {
                handlePaymentResult({
                    errors: { message: "Payment Card information is invalid" },
                    paymentStatus: "ERROR",
                });
                return false;
            }

            let pmtElement = elements.getElement(PaymentElement);
            pmtElement.update({ readOnly: true });
            let errorObj = null;
            let returnLocation = window.location.href;

            //stripe will return to return_url upon success
            stripeResponse = await stripe.confirmSetup({
                elements: elements,
                clientSecret: setupIntent.client_secret,
                confirmParams: {
                    return_url: returnLocation,
                },
                redirect: "if_required"
            });


            let paymentUpdateResp = {};
            if (stripeResponse.error) {
                await handlePaymentResult({ paymentStatus: 'ERROR', errors: { message: "Payment Error Code:" + stripeResponse.error.code + " " + stripeResponse.error.message } });
                return false;
            }
            if (stripeResponse.setupIntent.status === 'requires_action') {
                await handlePaymentResult({ paymentStatus: 'ERROR', errors: { message: "Payment gateway requires action which is not implemented yet." } });
                return false;
            } else if (stripeResponse.setupIntent.status === 'processing') {
                await handlePaymentResult({ paymentStatus: 'SUCCEEDED', errors: {}, response: stripeResponse.setupIntent });
                return;
            } else if (stripeResponse.setupIntent.status === 'requires_payment_method') {
                await handlePaymentResult({ paymentStatus: 'DECLINED', errors: { message: "Payment method was declined" } });
                return false;
            } else if (stripeResponse.setupIntent.status === 'succeeded') {
                await handlePaymentResult({ paymentStatus: 'SUCCEEDED', errors: {}, response: stripeResponse.setupIntent });
                return;
            } else if (stripeResponse.setupIntent.status === 'canceled') {
                await handlePaymentResult({ paymentStatus: 'CANCELLED', errors: { message: "Payment was cancelled" } });
                return false;
            } else {
                await handlePaymentResult({ paymentStatus: 'ERROR', errors: { message: "Unnown error in payment gateway" } });
                return false;
            }

        } catch (error) {
            let errorObj = extractError(error);
            await handlePaymentResult({ paymentStatus: 'ERROR', errors: errorObj });
        }

    }

    useEffect(() => {
        saveCardFunction.current = savePaymentCard
    }, [savePaymentCard])

    const handlePaymentElementChange = async (event) => {
        setPaymentElementComplete(event.complete);
    };

    return (
        <PaymentElement options={{
            layout: "tabs",
            defaultValues: {
                billingDetails: {
                    name: formData.firstName + " " + formData.lastName,
                    email: formData.email,
                    address: {
                        line1: formData.address,
                        city: formData.city,
                        state: formData.province,
                        country: formData.country,
                        postal_code: formData.zip,
                    }
                }

            }
        }} onChange={handlePaymentElementChange} />
    )
}


export default StripeElements